import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';

export const DeclaraBIDPreset = definePreset(Lara, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
    },
  },

  semantic: {
    primary: {
      0: 'var(--brand-0)',
      100: 'var(--brand-100)',
      200: 'var(--brand-200)',
      300: 'var(--brand-300)',
      400: 'var(--brand-400)',
      500: 'var(--brand-500)',
      600: 'var(--brand-600)',
      700: 'var(--brand-700)',
      800: 'var(--brand-800)',
      900: 'var(--brand-900)',
    },

    colorScheme: {
      light: {
        primary: {
          color: 'var(--brand-primary)',
          contrastColor: 'var(--white)',
          hoverColor: 'var(--brand-600)',
          activeColor: 'var(--brand-700)',
        },
        secondary: {
          color: 'var(--brand-secondary)',
        },

        surface: {
          0: 'var(--white)',
          50: 'var(--neutral-50)',
          100: 'var(--neutral-100)',
          200: 'var(--neutral-200)',
          300: 'var(--neutral-300)',
          400: 'var(--neutral-400)',
          500: 'var(--neutral-500)',
          600: 'var(--neutral-600)',
          700: 'var(--neutral-700)',
          800: 'var(--neutral-800)',
          900: 'var(--neutral-900)',
        },

        focusRing: {
          shadow: 'none',
        },
      },
    },
  },

  components: {
    accordion: {
      colorScheme: {
        light: {
          header: {
            background: '{surface.100}',
            color: '{primary.900}',
            hoverBackground: '{surface.200}',
            hoverColor: '{primary.900}',
            activeBackground: '{surface.100}',
            activeColor: '{primary.900}',
            activeHoverBackground: '{surface.200}',
            activeHoverColor: '{primary.900}',
          },
        },
      },
    },
    datatable: {
      colorScheme: {
        light: {
          headerCell: {
            background: '{surface.200}',
            color: '{primary.color}',
            padding: '1rem 1rem',
            hoverColor: '{primary.color}',
            hoverBackground: '{surface.300}',
            selectedBackground: '{surface.100}',
            selectedColor: '{primary.color}',
          },
        },
      },
    },
    select: {
      colorScheme: {
        light: {
          root: {
            disabledBackground: '{surface.200}',
            disabledColor: '{surface.500}',
          },
          option: {
            selectedBackground: '{primary.100}',
            selectedColor: '{primary.color}',
          },
        },
      },
    },
    multiselect: {
      colorScheme: {
        light: {
          root: {
            disabledBackground: '{surface.200}',
            disabledColor: '{surface.500}',
          },
          option: {
            selectedBackground: '{primary.100}',
            selectedColor: '{primary.color}',
          },
        },
      },
    },
    radiobutton: {
      colorScheme: {
        light: {
          root: {
            background: 'transparent',
            checkedBackground: 'transparent',
            checkedBorderColor: 'var(--brand-primary)',
            checkedHoverBorderColor: 'var(--brand-primary)',
            checkedHoverBackground: 'transparent',
          },
          icon: {
            checkedColor: 'var(--brand-primary)',
            checkedHoverColor: 'var(--brand-primary)',
          },
        },
      },
    },
    toggleswitch: {
      colorScheme: {
        light: {
          root: {
            background: 'var(--neutral-200)',
            hoverBackground: 'var(--neutral-300)',
            disabledBackground: 'var(--neutral-100)',
            checkedBackground: 'var(--brand-700)',
            checkedHoverBackground: 'var(--brand-600)',
            borderColor: 'transparent',
            hoverBorderColor: 'transparent',
            checkedBorderColor: 'transparent',
            checkedHoverBorderColor: 'transparent',
          },
          handle: {
            background: 'var(--white)',
            hoverBackground: 'var(--white)',
            disabledBackground: 'var(--white)',
            checkedBackground: 'var(--white)',
            checkedHoverBackground: 'var(--white)',
            color: 'var(--neutral-500)',
            hoverColor: 'var(--neutral-600)',
            checkedColor: 'var(--brand-700)',
            checkedHoverColor: 'var(--brand-700)',
          },
        },
      },
    },
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            background: 'var(--white)',
            hoverBackground: 'var(--neutral-50)',
            color: 'var(--brand-primary)',
            borderColor: 'var(--neutral-200)',
            disabledBackground: 'var(--white)',
            disabledColor: 'var(--neutral-500)',
            disabledBorderColor: 'var(--neutral-200)',
            checkedBackground: 'var(--success-200)',
            checkedColor: 'var(--neutral-900)',
            checkedBorderColor: 'var(--success-200)',
          },
          icon: {
            color: 'var(--brand-primary)',
            checkedColor: 'var(--neutral-900)',
            disabledColor: 'var(--neutral-500)',
          },
          content: {
            checkedBackground: 'transparent',
            checkedShadow: 'none',
          },
        },
      },
    },
  },
});
